import { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import useConnection from './use-connection';

const useSessionAvailabilityParams = () => {
  const { watch } = useFormContext();
  const duration = watch('duration');

  const { mentoringProgram } = useContext(MentoringProgramContext);
  const {
    id: mentorshipProgramId,
    mentorshipProgramEnrollment,
  } = mentoringProgram || {};

  const { connectionId } = useConnection(mentorshipProgramEnrollment);

  return {
    connectionId,
    mentorshipProgramId,
    duration,
  };
};

export default useSessionAvailabilityParams;
